<script setup lang="ts">
import { useToasts, removeToast } from './toast'

const toasts = useToasts()
</script>

<template>
  <div class="cToast__wrap">
    <transition-group name="cToast">
      <div
        v-for="t in toasts.items"
        :key="t.id"
        class="cToast"
        :class="`cToast--${t.type}`"
        role="status"
        @click="removeToast(t.id)"
      >
        <span class="cToast__icon" aria-hidden="true">
          <template v-if="t.type === 'success'">✓</template>
          <template v-else-if="t.type === 'error'">!</template>
          <template v-else>i</template>
        </span>
        <span class="cToast__text">{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.cToast__wrap {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
  max-width: min(360px, calc(100vw - 32px));
}

.cToast {
  pointer-events: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #2e2e33;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
}

.cToast--success { background: #1f9d55; }
.cToast--error { background: #d64545; }
.cToast--info { background: #2e2e33; }

.cToast__icon {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
}

.cToast__text { flex: 1 1 auto; }

/* Появление справа, исчезновение — плавно вверх/прозрачностью. */
.cToast-enter-active,
.cToast-leave-active { transition: all 0.25s ease; }
.cToast-enter-from { opacity: 0; transform: translateX(24px); }
.cToast-leave-to { opacity: 0; transform: translateX(24px); }
</style>
